import { __extends } from "tslib";
import { ActivityEvent } from './ActivityEvent';
var FullScreenEvent = /** @class */ (function (_super) {
    __extends(FullScreenEvent, _super);
    function FullScreenEvent(type, bubbles, cancelable, fullScreen, interactive) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (fullScreen === void 0) { fullScreen = false; }
        if (interactive === void 0) { interactive = false; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this.fullScreen = !!fullScreen;
        _this.interactive = !!interactive;
        return _this;
    }
    FullScreenEvent.classInitializer = null;
    FullScreenEvent.classSymbols = null;
    FullScreenEvent.instanceSymbols = null;
    // JS -> AS Bindings
    FullScreenEvent.FULL_SCREEN = 'fullScreen';
    FullScreenEvent.FULL_SCREEN_INTERACTIVE_ACCEPTED = 'fullScreenInteractiveAccepted';
    return FullScreenEvent;
}(ActivityEvent));
export { FullScreenEvent };
